/**
 * 线路班次模块接口
 * @description 线路、班次、站点、区域等相关接口
 */

import axios from "@/utils/request";
import Api from "../api";
import * as Request from "../request.type";
import * as ResponseData from "../response.type";

/**
 * 获取城市区域站点信息
 * @param type 上下行类型 1-上行 2-下行
 * @returns 城市区域站点信息
 */
export const Http_getCitysInfo = async (type: number) => {
  const res = await axios.get<ResponseData.CityAreaStationData[]>(
    Api.GET_CITY_AREA_STATIONS,
    {
      params: {
        upDown: type,
      } as Request.GetCityAreaStationsParams,
    }
  );
  if (res.code === 0) {
    const newArr = res.data;
    newArr.forEach((item) => {
      item.stations = item.areas;
    });
    return newArr;
  }
  return [];
};

/**
 * 获取运营公司列表
 */
export const Http_postOperateCompanyList = async (levelType: number) => {
  return await axios.post(Api.POST_OPERATE_COMPANY_LIST, {
    levelType,
  });
};

/**
 * 查询路线出发城市区域列表
 */
export const Http_getDepartureRouteCityAreaList = async () => {
  return await axios.get<ResponseData.getDepartureRouteCityAreaListData[]>(
    Api.GET_DEPARTURE_ROUTE_CITY_AREA_LIST
  );
};

/**
 * 通过出发城市区域信息查询路线到达城市区域列表
 */
export const Http_postDepartureRouteCityAreaList = async (
  params: Request.postDepartureRouteCityAreaListParams
) => {
  return await axios.post<ResponseData.getDepartureRouteCityAreaListData[]>(
    Api.GET_DEPARTURE_ROUTE_CITY_AREA_LIST,
    params
  );
};

/**
 * 获取所有关口站点
 */
export const Http_getAllGateWayStation = async () => {
  return await axios.get<
    {
      /** 站点ID */
      id: number;
      /** 站点名称 */
      nameCn: string;
    }[]
  >(Api.GET_ALL_GATEWAY_STATION);
};
